<template lang="pug">
  v-app
    router-view
    vue-progress-bar
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      //
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
